export const withNotApplicableFallback = (value) => {
  return value || 'N/A';
};
